function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.32 18.62h-6.05v-.02H16.1v-6.1c0-4.58 3.54-8.3 7.9-8.3a8 8 0 017.69 6.37h4.07C34.87 4.59 29.94 0 24 0c-6.56 0-11.9 5.6-11.9 12.5v6.1H11c-1.65 0-3 1.41-3 3.15v23.1A3.08 3.08 0 0011 48h26c1.65 0 3-1.41 3-3.15v-23.1a3.1 3.1 0 00-2.68-3.13zM36 43.8v-21H12v21h24zm-13.9-5.25h3.8c.57 0 1.01-.55.92-1.14L26 32.25l.27-1.15c.37-1.55-.75-3.05-2.27-3.05s-2.64 1.5-2.27 3.06l.27 1.14-.82 5.16c-.1.6.35 1.14.92 1.14z"
})));